import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import { connect } from 'react-redux';
import { Entities, patch } from 'src/common';

class AdminCompanySetInvisibleModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    render() {
        const { t, handleClose, patch, busCompany } = this.props;

        return (
            <div className="row">
                <div className="col-md-12" style={{ marginBottom: 10 }}>
                    <p>{t('companies.set_invisible.info_text')}</p>
                    <button
                        className="btn btn-primary pull-right"
                        onClick={() => {
                            patch({ id: busCompany.id }, Entities.BUS_COMPANY, 0, undefined, undefined, 'setInvisible');
                            handleClose();
                        }}>
                        {t('companies.set_invisible.approve')}
                    </button>
                    <button
                        className="btn pull-right"
                        onClick={() => {
                            handleClose();
                        }}>
                        {t('companies.set_invisible.cancel')}
                    </button>
                </div>
            </div>
        );
    }
}

export default connect(
    () => {
        return {};
    },
    { patch },
    null,
    { withRef: true },
)(AdminCompanySetInvisibleModal);
